import { hasMetricModeForProject } from '@resistapp/common/features';
import { MetricMode, User } from '@resistapp/common/types';

export function getOverviewAccessState(params: {
  user: User | undefined | null;
  metricMode: MetricMode;
  viableProjectId?: number | null;
}): 'loading' | 'granted' | 'redirect' {
  if (params.user === undefined) {
    return 'loading';
  }

  return params.viableProjectId != null && hasMetricModeForProject(params.user, params.metricMode, params.viableProjectId)
    ? 'granted'
    : 'redirect';
}
